import { MediaEntry, IMediaEntry } from 'app/constants/schemas/MediaEntry';
import { Text, IText } from 'app/constants/schemas/Text';

export interface IAttributes {
  mediaSize: string;
}

export interface IAssociations {
  captionText: IText | null;
  mediaEntries: IMediaEntry[];
}

// Attributes/associations shared by both MediaGroup and MediaSection.
export const attributes = {
  mediaSize: {
    type: 'string',
    notNull: true,
  },
};

export const associations = {
  captionText: Text,
  mediaEntries: [MediaEntry],
};
